<template>
    <div class="tab-pane fade show active position-relative" id="attributes" role="tabpanel" aria-labelledby="attributes-tab">
        <transition name="vue-table-loader">
            <div class="vue-details-loader" v-if="uiStates.showLoading"><span class="fa fa-cog fa-spin fa-1x"></span></div>
        </transition>
        <div class="product-form-tab">
            <product-lang-toggle @language-selection="updateLanguage"></product-lang-toggle>
            <form action="">
                <div class="form-element-container">
                    <div class="row pb-2 heading-container">
                        <div class="clearfix col-md-12">
                            <h3>{{panelName}}</h3>
                            <p class="text-muted mt-2 text-xs max-w-para">
                                Attributes are flexible fields that can be used to store all your custom data points.
                                Attributes can be grouped into attribute sets for easy assignment. These attribute sets
                                can then be assigned to products individually or in batches. This view displays all of
                                the currently-assigned attribute sets and their constituent attributes, which can be edited.
                            </p>
                            <div  v-if="productAttributes.assignedAttributes">
                                <div class="collapse-container mt-5"  v-if="productAttributes.assignedAttributes.length != 0">
                                    <a v-if="uiStates.collapsePanelToggle" class="view-collapse-all" href="#" v-on:click="collapseAll()">
                                        Collapse All
                                    </a>
                                    <a v-else class="view-collapse-all" href="#" v-on:click="expandAll()">
                                        Expand All
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="text-center" v-if="productAttributes.assignedAttributes">
                        <div class="alert alert-warning" v-if="productAttributes.assignedAttributes.length == 0" role="alert">
                            <span>No assigned attributes in this group</span>
                        </div>
                    </div>
                    <template v-for="(group, name) in productAttributes.assignedAttributes">
                        <div v-if="!uiStates.showLoading" :id="'atributeAccordion'+name" class="group-continer" :key="group + '_' + name">
                            <div class="" id="headingOne">
                                <a href="#" class="group-name" data-toggle="collapse" :data-target="'#attributeCollapse-'+name" aria-expanded="true" :aria-controls="'attributeCollapse-'+name">
                                    {{group.display_group}}
                                </a>
                            </div>
                            <div class="collapse show"
                                aria-labelledby="headingOne"
                                :id="group.display_group === 'Default' && !group.attributes.length ? false : 'attributeCollapse-'+name"
                                :data-parent="'#atributeAccordion'+name"
                            >
                                <div class="group-body">
                                    <div class="ml-0 row">
                                        <div v-if="group.display_group === 'Default' && !group.attributes.length">
                                            The Default group is empty, attributes can be added via the sidebar to the right
                                        </div>
                                        <template v-for="(field, index) in group.attributes">
                                            <div class="p-0 col-md-2 d-flex align-items-center justify-content-end" :key="'label_' + index">
                                                <label class="edit-in-place-label attribute-label">{{field.label}}:</label>
                                            </div>
                                            <div class="pb-2 col-md-10" :key="'field_' + index">
                                                <edit-in-place  v-if="field.type == 'text'"
                                                                type="short-text"
                                                                @value-save="handleEditInPlaceDataSaveEvent(field, $event)"
                                                                :is-master="isMaster"
                                                                :master-value="field.masterValue"
                                                                :propertyValue="field.value"
                                                                :read-only="readOnlySanitized(field.readonly)"
                                                                :show-schedule="hasScheduleFeature && hasSchedulePermission">
                                                    <api-handler :product-id="$parent.product.info.id" :attribute-id="field.id" :version-id="activeVersionId"></api-handler>
                                                </edit-in-place>
                                                <edit-in-place  v-if="field.type == 'selectbox'"
                                                                type="single-select"
                                                                @value-save="handleEditInPlaceDataSaveEvent(field, $event)"
                                                                :is-master="isMaster"
                                                                :master-value="field.masterValue"
                                                                :show-save-and-sync="true"
                                                                :options="singleSelectOptionsSanitized(field.options)"
                                                                :propertyValue="singleSelectValueSanitized(field.value, field.masterValue)"
                                                                :read-only="readOnlySanitized(field.readonly)"
                                                                :show-schedule="hasScheduleFeature && hasSchedulePermission">
                                                    <api-handler :product-id="$parent.product.info.id" :attribute-id="field.id" :version-id="activeVersionId"></api-handler>
                                                </edit-in-place>
                                                <edit-in-place  v-if="field.type == 'multiselect'"
                                                                type="multi-select"
                                                                @value-save="handleEditInPlaceDataSaveEvent(field, $event)"
                                                                :is-master="isMaster"
                                                                :master-value="field.masterValue"
                                                                :show-save-and-sync="true"
                                                                :options="multiSelectOptionsSanitized(field.options)"
                                                                :propertyValue="field.value"
                                                                :read-only="readOnlySanitized(field.readonly)"
                                                                :show-schedule="hasScheduleFeature && hasSchedulePermission">
                                                    <api-handler :product-id="$parent.product.info.id" :attribute-id="field.id" :version-id="activeVersionId"></api-handler>
                                                </edit-in-place>
                                                <edit-in-place  v-if="field.type == 'textarea'"
                                                                type="long-text"
                                                                @value-save="handleEditInPlaceDataSaveEvent(field, $event)"
                                                                :is-master="isMaster"
                                                                :master-value="field.masterValue"
                                                                :show-save-and-sync="true"
                                                                :propertyValue="field.value"
                                                                :read-only="readOnlySanitized(field.readonly)"
                                                                :show-schedule="hasScheduleFeature && hasSchedulePermission">
                                                    <api-handler :product-id="$parent.product.info.id" :attribute-id="field.id" :version-id="activeVersionId"></api-handler>
                                                </edit-in-place>
                                                <edit-in-place  v-if="field.type == 'date'"
                                                                type="date"
                                                                @value-save="handleEditInPlaceDataSaveEvent(field, $event)"
                                                                :is-master="isMaster"
                                                                :master-value="field.masterValue"
                                                                :show-save-and-sync="true"
                                                                :propertyValue="field.value"
                                                                :read-only="readOnlySanitized(field.readonly)"
                                                                :show-schedule="hasScheduleFeature && hasSchedulePermission">
                                                    <api-handler :product-id="$parent.product.info.id" :attribute-id="field.id" :version-id="activeVersionId"></api-handler>
                                                </edit-in-place>
                                                <edit-in-place  v-if="field.type == 'datetime'"
                                                                type="datetime"
                                                                @value-save="handleEditInPlaceDataSaveEvent(field, $event)"
                                                                :is-master="isMaster"
                                                                :master-value="field.masterValue"
                                                                :show-save-and-sync="true"
                                                                :propertyValue="field.value"
                                                                :read-only="readOnlySanitized(field.readonly)"
                                                                :show-schedule="hasScheduleFeature && hasSchedulePermission">
                                                    <api-handler :product-id="$parent.product.info.id" :attribute-id="field.id" :version-id="activeVersionId"></api-handler>
                                                </edit-in-place>
                                                <edit-in-place  v-if="field.type == 'markdown'"
                                                                type="markdown"
                                                                @value-save="handleEditInPlaceDataSaveEvent(field, $event)"
                                                                :is-master="isMaster"
                                                                :master-value="field.masterValue"
                                                                :show-save-and-sync="true"
                                                                :propertyValue="field.value"
                                                                :read-only="readOnlySanitized(field.readonly)"
                                                                :show-schedule="hasScheduleFeature && hasSchedulePermission">
                                                    <api-handler :product-id="$parent.product.info.id" :attribute-id="field.id" :version-id="activeVersionId"></api-handler>
                                                </edit-in-place>
                                                <small v-if="field.type == 'markdown'">To preview the markdown content click on the eye icon in the editor.</small>
                                                <edit-in-place  v-if="field.type == 'json'"
                                                                type="json"
                                                                @value-save="handleEditInPlaceDataSaveEvent(field, $event)"
                                                                :is-master="isMaster"
                                                                :master-value="field.masterValue"
                                                                :show-save-and-sync="true"
                                                                :propertyValue="field.value"
                                                                :read-only="readOnlySanitized(field.readonly)"
                                                                :show-schedule="hasScheduleFeature && hasSchedulePermission">
                                                    <api-handler :product-id="$parent.product.info.id" :attribute-id="field.id" :version-id="activeVersionId"></api-handler>
                                                </edit-in-place>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </form>
        </div>
    </div>
</template>

<script type="text/javascript">
    var base_url = window.location.protocol + "//" + window.location.host

    import Vue from 'vue';
    import VueEvents from 'vue-events'
    import axios from 'axios'
    import select2 from 'select2';
    import _ from 'lodash';

    import InputTextArea from '../form/form-textarea.vue';
    import InputCheckbox from '../form/form-checkbox.vue';
    import productLangToggle from './product-language-select.vue';
    // import nestedAttributeVue from './nested-attribute.vue';
    import FormWYSIWYG from '../form/form-wysiwyg';
    import InputMarkdown from '../form/form-markdown.vue';
    import EditInPlace from '../edit-in-place/edit-in-place.vue';
    import ProductDetailsAttributesAPI from './product-details-attributes-api-handler';

    Vue.use(VueEvents)

    export default {
        name: 'product-attributes',
        props: ['allAttributes'],
        components:{
            'input-textarea': InputTextArea,
            'input-checkbox': InputCheckbox,
            'product-lang-toggle': productLangToggle,
            // 'nested-attribute' : nestedAttributeVue,
            'form-wysiwyg': FormWYSIWYG,
            'input-markdown': InputMarkdown,
            'edit-in-place' : EditInPlace,
            'api-handler': ProductDetailsAttributesAPI,
        },
        data() {
            return {
                language: '',
                datepickerOptions: {},
                filteredDisplayGroupId: this.$route.params.displayGroupId,
                panelName: this.$route.params.panelName,
                uiStates: {
                    errorMessage: null,
                    showLoading: false,
                    collapsePanelToggle: true,
                },
                product: this.productDetails,
                productAttributes: {
                    items: {
                        groupingName: 'Default',
                        groupItems: [
                        ]
                    }
                },
                cmOptionsJS: {
                    tabSize: 4,
                    mode: 'application/json',
                    theme: 'default',
                    lineNumbers: true,
                    line: true,
                    matchBrackets: true,
                    matchTags: true,
                    autoCloseBrackets: true,
                    autoCloseTags: true,
                    extraKeys: {"Ctrl-Space":"autocomplete"},
                    lint: true,
                    gutters: ["CodeMirror-lint-markers"],

                },
                easyMDEConfigs : {
                    hideIcons : ['fullscreen', 'side-by-side']
                }
            }
        },
        mounted() {
            if( this.$parent.loadedPanelData.attributes) {
                this.productAttributes = this.$parent.productAttributes;
                this.uiStates.showLoading = false;
            }
            if( ! this.$parent.loadedPanelData.attributes) {
                this.loadAttributes();
                this.$parent.loadedPanelData.attributes = true;
            }
        },
        created() {},
        watch: {
            '$route': 'checkRouteChange',
            '$parent.languages.active': 'checkLangChange',
        },
        computed: {
            activeVersionId() {
                return parseInt(this.$parent.languages.active, 10);
            },
            isMaster() {
                return (this.activeVersionId === 0);
            },
            isNotMaster() {
                return !this.isMaster;
            },
            hasScheduleFeature() {
                return this.$parent.featureAllowed('scheduled_content');
            },
            hasSchedulePermission() {
                return this.$parent.permissionAllowed('schedule_content');
            }
        },
        methods: {
            handleEditInPlaceDataSaveEvent(field, newData) {
                if (field.type === 'selectbox') {
                    field.value[0] = newData;
                } else {
                    field.value = newData;
                }
            },
            updateLanguage(lang) {
                this.language = lang;
            },
            readOnlySanitized(value) {
                if (!this.$parent.permissionAllowed('manage_products')) {
                    return true;
                }
                if (value === 1) {
                    return true;
                }

                if (value === 0) {
                    return false;
                }

                return !!value;
            },
            singleSelectValueSanitized(value, masterValue) {
                if (!value[0] && this.isNotMaster) {
                    return masterValue
                }

                return value[0]
            },
            singleSelectOptionsSanitized(options) {
                let sObj = [];
                for (var key of Object.keys(options)) {
                    sObj.push({value: key, label:options[key].value});
                }
                return sObj;
            },
            multiSelectOptionsSanitized(options) {
                let sObj = [];
                for (var key of Object.keys(options)) {
                    sObj.push({id:options[key].id, name:options[key].value});
                }
                return sObj;
            },
            collapseAll() {
                this.uiStates.collapsePanelToggle = !this.uiStates.collapsePanelToggle;

                $('.group-continer .collapse').collapse('hide')
            },
            expandAll() {
                this.uiStates.collapsePanelToggle = !this.uiStates.collapsePanelToggle;

                $('.group-continer .collapse').collapse('show')
            },
            checkRouteChange() {
                this.filteredDisplayGroupId =  this.$route.params.displayGroupId;
                this.$parent.filteredDisplayGroupId = this.filteredDisplayGroupId;
                this.loadAttributes();
                this.uiStates.collapsePanelToggle = true;
                this.panelName =  this.$route.params.panelName;
            },
            checkLangChange() {
                this.uiStates.showLoading = true;
                this.productAttributes = [];
                this.loadAttributes();
            },
            loadAttributes: function() {
                this.uiStates.showLoading = true;
                let getRoute;
                if (this.filteredDisplayGroupId) {
                    getRoute = base_url+ '/pimapi/products/'+this.$parent.product.info.id+'/attributes/details/'+ this.$parent.languages.active +'/'+this.filteredDisplayGroupId;
                }else{
                    getRoute = base_url+ '/pimapi/products/'+this.$parent.product.info.id+'/attributes/details/' + this.$parent.languages.active;
                }

                axios.get(getRoute, {
                    // 'filteredDisplayGroupId': this.filteredDisplayGroupId,
                })
                .then(function (response) {
                    this.productAttributes = response.data;
                    this.$parent.productAttributes = this.productAttributes;
                    this.uiStates.showLoading = false;
                }.bind(this))
                .catch(function (error) {
                    this.uiStates.showLoading = false;
                    this.$parent.alert.status = "alert-danger";
                    this.$parent.alert.message = 'An error has occured!';
                }.bind(this));
            },
            saveProductAttributes: function () {
                this.uiStates.showLoading = true;
                axios.post(base_url + '/pimapi/products/' + this.$parent.product.info.id + '/attributes/details/' + this.$parent.languages.active, {
                    'filteredDisplayGroupId': this.filteredDisplayGroupId,
                    'data': this.productAttributes.assignedAttributes,
                })
                .then(function(response) {
                    this.$parent.alert.status = "alert-success";
                    this.$parent.alert.message = "Product Attributes successfully saved";
                    this.uiStates.showLoading = false;
                }.bind(this))
                .catch(function (error) {
                    this.uiStates.showLoading = false;
                    this.$parent.alert.status = "alert-danger";
                    this.$parent.alert.message = 'An error has occured!';
                }.bind(this));
            },
            setAttribute(thisAttribute) {
                thisAttribute.active_child = {};
                delete thisAttribute.active_child;

                if(Array.isArray(thisAttribute.value)) {
                    return;
                }

                let selected_value = thisAttribute.value;

                for(let child in thisAttribute.options) {
                    if(selected_value === thisAttribute.options[child].value ) {
                        var child_id = thisAttribute.options[child].child_id;
                        if(child_id === undefined){
                            child_id = thisAttribute.options[child].child_id;
                        }
                    }
                }

                if(child_id === undefined) {
                    this.$forceUpdate();
                    return;
                }

                for(let i = 0; i < this.productAttributes.allAttributes.length; i++) {
                    if(this.productAttributes.allAttributes[i].id === child_id){
                        var child_attribute = this.productAttributes.allAttributes[i];
                    }
                }

                if(child_attribute === undefined) {
                    this.$forceUpdate();
                    return;
                }

                child_attribute.options = child_attribute.typeValuesArray;
                child_attribute.label = child_attribute.name;
                child_attribute.value = "";
                thisAttribute.active_child = child_attribute;
                this.$forceUpdate();
            },
            findObjectByKey(array, key, value) {
                for(var i = 0; i < array.length; i++) {
                    if(array[i][key] === value) {
                        var foundArray = array[i];
                            foundArray.index = i;
                        return foundArray;
                    }
                }
                return null;
            },
            checkObjectExists(array, key, value) {
                for(var i = 0; i < array.length; i++) {
                    if(array[i][key] === value) {
                        return false;
                    }
                }
                return true;
            },
            colWidth: function(field) {
                if(field == 'json' || field == 'markdown'){
                    return 'col-md-12';
                }

                return 'col-md-6';
            }
            // New method
            // Check the value against the children - if
        },
    };
</script>

<style lang="scss">
    @import "~easymde/dist/easymde.min.css";
    // @import "~vue-codemirror/node_modules/codemirror/addon/lint/lint.css";
    .CodeMirror {
        padding: 0px;
    }
</style>

<style scoped lang="scss">

.attribute-label {
    text-align: right;
    line-height: 1.3em;
}
.heading-container{
    margin-bottom: 20px;
}
.group-continer{
    margin-bottom:30px;
}
.group-name{
    position: relative;
    padding: 10px;
    display: block;
    font-size: 14px;
    color: #586670;
    border: 1px solid #dedede;
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
    background-color: #f5f6fa;
    &:before{
        content: "\F110";
        font: normal normal normal 12px/1 "LineAwesome";
        position: absolute;
        right: 10px;
        top: 14px;
        transform: rotate(-180deg);
    }
    &.collapsed{
        border-bottom-right-radius: 5px;
        border-bottom-left-radius: 5px;
        &:before{
            content: "\F110";
            font: normal normal normal 12px/1 "LineAwesome";
            transform: rotate(0deg);
        }
    }
}
.group-body {
    border-left: 1px solid #dedede;
    padding: 10px 10px 0px 10px;
    border-right: 1px solid #dedede;
    border-bottom: 1px solid #dedede;
    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 5px;
}
.view-collapse-all{
    position: absolute;
    color:#3191FF;
    right: 15px;
}
.alert{
    overflow:hidden;
    padding: 9px 20px;
    &.alert-info{
        color: #0c7b94 !important;
        border-color: #02a7cd !important;
        background: rgba(206, 245, 255, 0.7) !important;
    }
    &.alert-danger{
        color: #581c21 !important;
        border-color: #f1d2cc !important;
        background: #fbeaec !important;
    }
    &.alert-warning{
        color: #856404;
        background-color: #fff3cd;
        border-color: #f1e1b1;
    }
}
</style>
